import { IFRSQuestionDTO } from "../../../api/Quiz/GetIFRSQuestions";
import IFRSQuestionRow from "./IFRSQuestionRow";

interface IFRSQuestionsTableProps {
  data?: IFRSQuestionDTO[];
  examId: string;
  onDelete?: (questionId: string) => void;
}

const IFRSQuestionsTable = ({
  data,
  examId,
  onDelete,
}: IFRSQuestionsTableProps) => {
  return (
    <div>
      <div className="overflow-x-auto scrollbar-thumb-blue scrollbar-thumb-rounded scrollbar-track-blue-lighter scrollbar-w-2 scrolling-touch">
        <table className="table-auto w-full">
          <thead className="text-lg capitalize">
            <tr className="bg-[#F1F4F9] rounded-t-lg">
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">ID</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Description</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Requirements</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Marks</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Exhibits</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Response Options</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Actions</div>
              </th>
            </tr>
          </thead>
          <tbody className="text-sm">
            {data && data.length > 0 ? (
              data.map((question: IFRSQuestionDTO) => (
                <IFRSQuestionRow
                  key={question.id}
                  question={question}
                  examId={examId}
                  onDelete={onDelete}
                />
              ))
            ) : (
              <tr>
                <td
                  colSpan={8}
                  className="px-2 first:pl-5 last:pr-5 py-8 text-center"
                >
                  <div className="text-sm text-gray-500">
                    No questions found
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default IFRSQuestionsTable;
